<template>
    <svg width="16px" height="20px" viewBox="0 0 16 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Comps" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Public-Profile---Edit" transform="translate(-775.000000, -2023.000000)">
                <g id="i-trash" transform="translate(773.000000, 2023.000000)">
                    <g id="Group-20" transform="translate(2.000000, 0.000000)" stroke="#FFFFFF">
                        <path d="M1.57155811,6.5 L3.31560253,19.5 L12.6963502,19.5 L14.4289408,6.5 L1.57155811,6.5 Z" id="Rectangle"></path>
                        <rect id="Rectangle" x="0.5" y="3.5" width="15" height="3"></rect>
                        <rect id="Rectangle-Copy-11" x="4.5" y="0.5" width="7" height="3"></rect>
                    </g>
                    <rect id="Rectangle" x="0" y="0" width="20" height="20"></rect>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: "IconDelete"
};
</script>